import React from "react";
import { BASE_10 } from "../constants";
import ICustomer from "../interfaces/ICustomer";
import ITransaction from "../interfaces/ITransaction";
import formatDate from "../utils/formatDate";
import formatOgsDollar from "../utils/formatOgsDollar";
import API from "../utils/OGSAPI";
import t from "../utils/t";
import NotFoundPage from "./NotFoundPage";

interface IProps {
    customer?: ICustomer;
}

interface IState {
    fetchingTransactions: boolean;
    transactions: ITransaction[];
}

export default class TransactionsPage extends React.Component<IProps, IState> {
    public state: IState = {
        fetchingTransactions: false,
        transactions: [],
    };
    public componentDidMount(): void {
        this.componentWillReceiveProps({});
    }
    public componentWillReceiveProps(nextProps: IProps): void {
        if (this.props.customer === nextProps.customer) {
            return;
        }

        this.setState({
            fetchingTransactions: true,
            transactions: [],
        });
        API.fetchTransactions().then((transactions: ITransaction[]): void => {
            transactions.sort((a: ITransaction, b: ITransaction): number => {
                return parseInt(b.id, BASE_10) - parseInt(a.id, BASE_10);
            });
            this.setState({
                fetchingTransactions: false,
                transactions,
            });
        });
    }
    public render(): JSX.Element {
        const { fetchingTransactions, transactions } = this.state;
        const { customer } = this.props;
        if (!customer) {
            return (
                <NotFoundPage />
            );
        }
        if (fetchingTransactions) {
            return (
                <div className="content-wrapper">
                    Loading..
                </div>
            );
        }

        if (!transactions.length) {
            return (
                <div className="content-wrapper">
                    There are no transactions to display.
                </div>
            );
        }

        return (
            <div className="content-wrapper">
                <div>Transactions</div>
                <table className="table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Date</th>
                            <th>Type</th>
                            <th>Description</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        { transactions.map((tx: ITransaction): JSX.Element => {
                            return (
                                <tr key={ tx.id }>
                                    <td>{ tx.id }</td>
                                    <td>{ formatDate(tx.createdTimestamp) }</td>
                                    <td>{ t([`TRANSACTION_LABELS.${ tx.name }`, tx.name]) }</td>
                                    <td>{ tx.description }</td>
                                    <td>{ formatOgsDollar(tx.amount, { symbolPrefix: "$" }) }</td>
                                </tr>
                            );
                        }) }
                    </tbody>
                </table>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/TransactionsPage.tsx